module.exports = __webpack_public_path__ + "static/media/Instructions-after-trail.7f786554.mp3";